import React, { useState } from 'react';
import './DesignSection.css';

const DesignSection = () => {
  const [activeDesign, setActiveDesign] = useState(0);

  const designs = [
    { name: 'E-Commerce', color: '#667eea' },
    { name: 'Portfolio', color: '#f093fb' },
    { name: 'Dashboard', color: '#4facfe' },
    { name: 'Blog', color: '#43e97b' },
    { name: 'Corporate', color: '#fa709a' },
    { name: 'Landing Page', color: '#30cfd0' },
    { name: 'SaaS', color: '#a8edea' },
    { name: 'Education', color: '#ffd89b' },
    { name: 'Healthcare', color: '#19d1c8' },
    { name: 'Real Estate', color: '#f5576c' }
  ];

  return (
    <section className="design-section section">
      <div className="section-content">
        <h2 className="section-title">Responsive Design Showcase</h2>
        
        <div className="design-selectors">
          {designs.map((design, index) => (
            <div
              key={index}
              className={`design-selector ${activeDesign === index ? 'active' : ''}`}
              onClick={() => setActiveDesign(index)}
              style={{ '--selector-color': design.color }}
              title={design.name}
            />
          ))}
        </div>

        <div className="devices-container">
          {/* Desktop */}
          <div className="device desktop">
            <div className="device-frame">
              <div className="device-screen" style={{ background: `linear-gradient(135deg, ${designs[activeDesign].color}, ${designs[activeDesign].color}99)` }}>
                <div className="screen-content">
                  <div className="content-header">
                    <div className="header-item"></div>
                    <div className="header-item"></div>
                    <div className="header-item"></div>
                  </div>
                  <div className="content-body">
                    <div className="body-title">{designs[activeDesign].name}</div>
                    <div className="body-text">Desktop View</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="device-stand"></div>
          </div>

          {/* Laptop */}
          <div className="device laptop">
            <div className="device-frame">
              <div className="device-screen" style={{ background: `linear-gradient(135deg, ${designs[activeDesign].color}, ${designs[activeDesign].color}99)` }}>
                <div className="screen-content">
                  <div className="content-header">
                    <div className="header-item"></div>
                    <div className="header-item"></div>
                  </div>
                  <div className="content-body">
                    <div className="body-title">{designs[activeDesign].name}</div>
                    <div className="body-text">Laptop View</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="laptop-base"></div>
          </div>

          {/* Tablet */}
          <div className="device tablet">
            <div className="device-frame">
              <div className="device-screen" style={{ background: `linear-gradient(135deg, ${designs[activeDesign].color}, ${designs[activeDesign].color}99)` }}>
                <div className="screen-content">
                  <div className="content-header">
                    <div className="header-item"></div>
                  </div>
                  <div className="content-body">
                    <div className="body-title">{designs[activeDesign].name}</div>
                    <div className="body-text">Tablet View</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile */}
          <div className="device mobile">
            <div className="device-frame">
              <div className="notch"></div>
              <div className="device-screen" style={{ background: `linear-gradient(135deg, ${designs[activeDesign].color}, ${designs[activeDesign].color}99)` }}>
                <div className="screen-content">
                  <div className="content-body">
                    <div className="body-title">{designs[activeDesign].name}</div>
                    <div className="body-text">Mobile View</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default DesignSection;
